import React from 'react'
import { useTranslation } from "react-i18next"

function ReviewStations({ pickupStation, pickupDate, dropOffStation, dropOffDate, children }) {
  const { t } = useTranslation()

  return (
    <div className="row pr-3 pl-3">
      <div className="col-6 col-lg-4">
        <div className="out w-100 color-green"><b>{t('return')}</b></div>
        <p className="pt-2">{pickupStation}<br />{pickupDate}</p>
      </div>
      <div className="col-6 col-lg-4">
        <div className="out w-100 color-green"><b>{t('dropoff')}</b></div>
        <p className="pt-2">{dropOffStation}<br />{dropOffDate}</p>
      </div>
      {children}
    </div>
  )
}

export default ReviewStations
